// extracted by mini-css-extract-plugin
export default {"host":"CAMHost_host__2dBjN"};